import React from "react"
import { graphql } from "gatsby"
import { Container, Header } from 'semantic-ui-react'
import Layout from '../components/layout'
import SEO from "../components/seo"

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  return (
    <Layout>
      <SEO title={frontmatter.title} />
      <Container text className="blog-post-content">
        <Header as='h1'>{frontmatter.title}</Header>
        <Header as='h3'>{`${frontmatter.date} . ${frontmatter.time}`}</Header>
        <div
          className="blog-post-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </Container>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        time
      }
    }
  }
`
